import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Link } from '../../../Elements/Link';
import { List } from '../../../Navigation/List/list';

export const FooterNavigationList = ({ navigations }) => {
  const footerNavigationListItems = navigations.items?.map((navigation) => {
    if (navigation.text) {
      return {
        spacing: 'hidden sm:block py-3',
        children: (
          <div className='text-2xl text-white'>
            <Label
              {...navigation}
              size='inherit'
              weight='medium'
            />
          </div>
        ),
      };
    }

    return {
      spacing: 'py-2',
      children: (
        <div className='text-white'>
          <Link
            {...navigation}
            label={{
              ...navigation.label,
              weight: 'light',
              size: 'base',
              type: 'span',
              color: { classname: 'white' },
            }}
          />
        </div>
      ),
    };
  });

  return (
    <nav aria-labelledby='solutions-heading'>
      <List listItems={footerNavigationListItems} />
    </nav>
  );
};
